<template>
  <div v-if="active" class="mb-1">
    <div class="form-check">
      <input id="dm_heureka_consent" type="checkbox" class="form-check-input" :checked="!consents.customerSatisfactionSurvey" @change="updateValue">
      <label class="form-check-label" for="dm_heureka_consent">
        {{ translations['I disagree with participating in customer satisfaction survey'] }}
        <span v-if="showLink">
          <a :href="linkUrl" target="_blank" class="dm_heureka_consent_link">{{ linkName }}</a>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      consents: state => state.consents,
      modules: state => state.config.modules,
    }),
    module () {
      return this.modules.dm_heureka ? this.modules.dm_heureka : null;
    },
    active () {
      return !!(this.module && this.module.enabled && this.module.consent);
    },
    showLink () {
      return this.active && this.module.cms.show;
    },
    linkUrl () {
      return this.module.cms.link;
    },
    linkName () {
      return this.module.cms.name;
    }
  },
  methods: {
    updateValue (e) {
      this.$store.commit('SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY', !e.target.checked);
    }
  },
  mounted: function() {
    if (this.active === false) {
      return;
    }
    this.$store.commit('SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY', true);
  },
};
</script>

<style scoped>
  .dm_heureka_consent_link {
    text-decoration: underline;
  }
</style>
